import { Component, OnInit } from '@angular/core';
import { DrawersService } from '../drawers.service';

@Component({
  selector: 'app-content-drawer',
  templateUrl: './content-drawer.component.html',
  styleUrls: ['./content-drawer.component.scss'],
})
export class ContentDrawerComponent implements OnInit {
  readonly contentDrawer$ = this._drawers.contentDrawerChanged$;
  constructor(private _drawers: DrawersService) {}

  ngOnInit() {}

  closeDrawer() {
    const drawer = this._drawers.getDrawer('columnsDrawer');
    if (drawer) {
      drawer.close();
    }
  }
}
